export default __webpack_public_path__ + "static/media/notifications-green.0f14cb7e.svg";